<template>
    <div >
      <Card>
            <p slot="title">
                Division
            </p>
                <Button
                    v-show="canCreateDivision()"
                    type="primary"
                    slot="extra"
                    @click="modal.createDivision=true"
                    size="small"  >
                    Tambah
                </Button>
                <template>
                        <Table border :columns="columnTableDivision" :data="divisions"></Table>

                </template>
        </Card>
        <template>
            <Modal v-model="modal.createDivision" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Tambah Division</span>
                </p>
                        <Form ref="formDivision" :model="formDivision" :rules="ruleValidate">
                            <Form-item label="Division Name" prop="divisionName">
                                <Input v-model="formDivision.divisionName" placeholder="Division Name"></Input>
                            </Form-item>
                        </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingCreateDivision"
                        @click="postCreateDivision" >
                        <span v-if="!loadingCreateDivision">Simpan</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.editDivision" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Edit Division</span>
                </p>
                <Form ref="formEditDivision" :model="formEditDivision" :rules="ruleValidate">
                    <Form-item label="Division Name" prop="divisionName">
                        <Input style="display: none;" v-model="formEditDivision.id" placeholder="Id Division Name"></Input>
                        <Input v-model="formEditDivision.divisionName" placeholder="Division Name"></Input>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingEditDivision"
                        @click="postEditDivision" >
                        <span v-if="!loadingEditDivision">Edit</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
    </div>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {


        user : {
            username : '',
            role : ''
        },
        modal : {
            createDivision : false,
            editDivision : false,
        } ,
        loadingSearch: false,
        loadingCreateDivision: false,
        loadingEditDivision: false,
        divisions : [],
        formDivision: {
            divisionName: '',
        },
        formEditDivision: {
            divisionName: '',
        },
        ruleValidate: {
            divisionName: [
                { required: true, message: 'Masukkan Division Name', trigger: 'blur' }
            ],
        },
        columnTableDivision: [
            {
                title: 'Division Name',
                key: 'division_name'
            },
            {
                title: 'Action',
                key: 'action',
                width: 120,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'success',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.show(params.index)
                                }
                            }
                        }, 'Edit')
                    ]);
                }
            }
        ],
    }},

  methods: {
    canCreateDivision () {
        let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], this.user.role);
        //console.log('this.user.role = ' + this.user.role)
        //console.log('canAccess = ' + canAccess)
        return canAccess;
    },
    handleSubmit (name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.createDivision();
            } else {
                this.$Message.error('Data masih belum lengkap');
            }
        })
    },
    show: function(index){
        var editDivisionId = this.divisions[index].id;
        this.formEditDivision.id = editDivisionId;

        var editDivisionName = this.divisions[index].division_name;
        this.formEditDivision.divisionName = editDivisionName;
        //console.log(this.divisions[index].id);
        this.modal.editDivision = true;
    },
    getDivision: function(){
        this.loadingSearch  = true;
        this.divisions = []
        HTTP
            .post('division/list')
            .then(response => {
                this.loadingSearch  = false;
                this.divisions = response.data
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    postCreateDivision:function(){
            this.loadingCreateDivision = true;

            let deptNameExist = _.some(this.divisions, {deptName: this.formDivision.deptName });

            if(deptNameExist){
                this.$Message.error('Dept name sudah ada');
                this.loadingCreateDivision = false;
                return false;
            }

            HTTP
            .post('division/create', {
                division_name: this.formDivision.divisionName  ,
            })
            .then(response => {
                this.loadingCreateDivision = false;
                this.modal.createDivision = false;
                this.formDivision.divisionName = '';

                this.$Message.success('Item Dept Created');
                this.getDivision();
            })
            .catch(e => {
                this.loadingCreateDivision = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    postEditDivision:function(){
            this.loadingEditDivision = true;

            let deptNameExist = _.some(this.divisions, {division_name: this.formEditDivision.divisionName });

            if(deptNameExist){
                this.$Message.error('Dept name sudah ada');
                this.loadingEditDivision = false;
                return false;
            }

            HTTP
            .post('division/update', {
                id: this.formEditDivision.id  ,
                division_name: this.formEditDivision.divisionName  ,
            })
            .then(response => {
                this.loadingEditDivision = false;
                this.modal.editDivision = false;
                this.formEditDivision.divisionName = '';

                this.$Message.success('Item Dept Edited');
                this.getDivision();
            })
            .catch(e => {
                this.loadingEditDivision = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    }
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getDivision();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// Division.vue?77aa26c8